export default __webpack_public_path__ + "static/media/yes.843e589b.png";